export default __webpack_public_path__ + "static/media/photo--lg--group-jump.51cd5a3d.jpg";